<template>
  <page-header title="Ticket de modificación masiva" :breadcrumRoutes="routes">
    <template #tags>
      <tags :color="headerStateData.color">
        {{ headerStateData.text }}
      </tags>
      <tags color="processing">ID: {{ ticketGroupId }}</tags>
    </template>

    <template #buttons>
      <a-button
        v-if="
          headerStateData.text == 'EN ASEGURADORA' ||
          headerStateData.text == 'Creado'
        "
        @click="handleCancel"
        :loading="loading"
        :disabled="loading"
      >
        Cancelar
      </a-button>
      <a-button
        class="ml-2"
        v-if="headerStateData.text == 'EN ASEGURADORA'"
        @click="handleExecuted"
        type="primary"
        :loading="loading"
        :disabled="loading"
      >
        Ejecutar
      </a-button>
    </template>
  </page-header>

  <stepper
    :state="stepperProps.state"
    :stateDates="stepperProps.dates"
    ticketType="baja"
    ref="stepperRef"
  />
  <a-card>
    <a-row :gutter="[16, 8]">
      <a-col :xs="24" :md="12">
        <datos-ticket
          :loadTicket="loadTicket"
          :data="tableData"
          title="Datos ticket"
        />

        <mensaje-aseguradora
          v-if="userRole != 'rrhh'"
          class="mt-3"
          :message="insuranceMessage"
        />
      </a-col>

      <a-col :xs="24" :md="12">
        <documentos-adjuntos
          title="Documentos adjuntos"
          :data="attachedFiles"
          :loading="loadingDocument"
        />

        <comments
          v-if="userRole != 'rrhh'"
          class="mt-3"
          :comments="comments"
          ticketType="masive"
          :idToTicket="ticketGroupId"
          @new_comment="getNewCommment"
        />
      </a-col>
    </a-row>
  </a-card>
</template>

<script>
import { reactive, ref } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { useStore } from 'vuex';
import { ExclamationCircleOutlined } from '@ant-design/icons-vue';
import { message } from 'ant-design-vue';
import { Modal } from 'ant-design-vue';
import { createVNode } from 'vue';
import {
  GET_AM_DETAIL,
  FETCH_AM_DETAIL,
  GET_AM_DETAIL_FILE,
  FETCH_AM_DETAIL_FILE,
  SUCCESS_MASSIVE_EXCLUSION,
  CANCEL_MASSIVE_MODIFICATION,
  EXECUTE_MASSIVE_MODIFICATION,
  FETCH_MASSIVE_COMMENTS,
  GET_LOGGED_USER,
  FETCH_USER_BY_ID,
  FETCH_TICKET_ID
} from '@/store/types';
import parseDate from '@/utils/dateFormatter';
import { useTicketStepper } from '@/composables/use-ticket-stepper';

// Components
import PageHeader from '@/components/page-header.vue';
import DatosTicket from '@/components/tickets/ticket-data.vue';
import Comments from '@/components/tickets/comments.vue';
import MensajeAseguradora from '@/components/tickets/insurer-message.vue';
import DocumentosAdjuntos from '@/components/tickets/attached-documents.vue';
// Utils
import openNotificationWithIcon from '@/utils/notifications';
import Tags from '@/components/tags.vue';
import rutHelper from '@/utils/Ruts';
import Stepper from '@/components/tickets/stepper.vue';

export default {
  name: 'ModificacionMasivaDetalle',
  components: {
    Stepper,
    'page-header': PageHeader,
    comments: Comments,
    'datos-ticket': DatosTicket,
    'mensaje-aseguradora': MensajeAseguradora,
    'documentos-adjuntos': DocumentosAdjuntos,
    tags: Tags
    // 'info-circle-outlined': InfoCircleOutlined,
    // 'check-circle-outlined': CheckCircleOutlined
  },
  setup() {
    const rules = {
      message: [
        {
          required: true,
          message: 'Ingrese un mensaje',
          trigger: 'change',
          type: 'string'
        }
      ],
      fileList: [
        {
          type: 'array',
          required: true,
          message: 'Adjunte un archivo',
          trigger: 'change'
        }
      ]
    };
    const route = useRoute();
    const finishAlta = ref(false);
    const formRef = ref();
    const nameFile = ref('');
    const store = useStore();
    const ticketGroupId = route.params.id;
    const loadingDocument = ref(false);
    const loadTicket = ref(false);

    // * Rutas
    const routes = [
      {
        path: '/modificaciones',
        breadcrumbName: 'Modificaciones'
      },
      {
        path: '/modificaciones#massive',
        breadcrumbName: 'Masiva'
      },
      {
        breadcrumbName: `#${ticketGroupId}`
      }
    ];

    const records = reactive([]);
    const formState = reactive({
      message:
        'A través del presente correo solicitamos cancelar la información contenida en este correo, debido a que existe un error en el documento adjunto. Se generará otra solicitud con el archivo correcto.',
      fileList: []
    });
    const handleRemove = () => {
      formState.fileList = [];
      formRef.value.validate('fileList');
    };
    const beforeUpload = (file) => {
      nameFile.value = file.name;
      const fileSize = file.size / 1024 / 1024;
      if (fileSize > 5) {
        message.error('El archivo excede el peso máximo 5MB');
      } else {
        formState.fileList[0] = file;
      }
      return false;
    };
    //* Get Data
    const ticketData = ref({});
    const router = useRouter();
    const getTicketData = async () => {
      loadTicket.value = true;
      try {
        await store
          .dispatch(FETCH_AM_DETAIL, ticketGroupId)
          .catch(() => router.push({ name: 'Missing' }));
        ticketData.value = await store.getters[GET_AM_DETAIL];
        if (ticketData.value.typeTicketGroupId != 3) {
          router.push({ name: 'Missing' });
        }

        fillTableData();
        getBroker();
        fillIndividualTable();
        stepperData(ticketGroupId);
        loadTicket.value = true;
      } catch (error) {
        openNotificationWithIcon(
          'error',
          'Error',
          error.response?.data
            ? error.response?.data?.message
            : 'Ocurrió un error. Favor intentar más tarde.'
        );
        console.log('error', error);
      }

      // fillRecordsWithStates(value_to_records);
    };
    getTicketData();

    const attachedFiles = ref([]);
    const getAttachedFiles = async () => {
      loadingDocument.value = true;
      try {
        await store
          .dispatch(FETCH_AM_DETAIL_FILE, ticketGroupId)
          .catch((err) =>
            openNotificationWithIcon(
              'error',
              'Error',
              `Error al cargar archivo del Ticket. ${
                err.response.data ? err.response.data.message : 'error'
              }`
            )
          );
        attachedFiles.value = await store.getters[GET_AM_DETAIL_FILE];
        loadingDocument.value = false;
      } catch (error) {
        loadingDocument.value = false;
        console.log('error', error);
        openNotificationWithIcon(
          'error',
          'Error',
          error.response.data ? error.response.data.message : 'error'
        );
      }
    };
    getAttachedFiles();

    const tableData = reactive([
      { key: 'Broker', value: '' },
      { key: 'Aseguradora', value: '' },
      { key: 'Holding', value: '' },
      { key: 'Subholding', value: '' },
      { key: 'Empresa', value: '' },
      { key: 'RUT Empresa', value: '' }
    ]);
    const insuranceMessage = ref('');

    const fillTableData = () => {
      tableData[1].value = ticketData.value.object.insuranceCompany;
      tableData[2].value = ticketData.value.object.holding;
      tableData[3].value = ticketData.value.object.subHolding;
      tableData[4].value = ticketData.value.object.company;
      tableData[5].value = rutHelper.formatRut(
        ticketData.value.object.rutCompany
      );

      insuranceMessage.value = ticketData.value.message;
    };

    const getBroker = async () => {
      const response = await store.dispatch(
        FETCH_USER_BY_ID,
        ticketData.value.object?.brokerId
      );
      if (response) {
        tableData[0].value = response.data.body.name;
      } else {
        tableData[0].value = '';
      }
    };

    const altasData = ref([]);
    const fillIndividualTable = () => {
      altasData.value = ticketData.value.ticketGroupStates.map((a) => {
        return {
          key: a.id,
          id: a.id,
          employeeName: `${a.employee?.firstName} ${a.employee?.firstSurname}`,
          employeeRut: a.employee?.rut,
          ticketState: a.state,
          pendingCases: a.cases === 0 ? 'No' : 'Sí'
        };
      });
    };

    const payloadObject = ref({});
    const loading = ref(false);
    const visible = ref(false);
    const showModalCancel = ref(false);
    const modalStyle = reactive({
      title: '',
      text: '',
      contentText: '',
      mode: ''
    });
    // * Stepper
    const stepperRef = ref('null');
    const cancelTicket = ref(false);

    const {
      stepperProps,
      headerStateData,
      rebuild: rebuildStepper
    } = useTicketStepper(null, {
      onCancel: () => stepperRef.value?.cancelStep?.(),
      onFinish: () => stepperRef.value?.finishStep?.(),
      // Preserve the original (buggy) behavior of the massive view: it
      // never deleted future-state dates from the stepper date map.
      pruneFutureStates: false
    });

    const handleOk = () => {
      visible.value = false;
      loading.value = false;
    };
    const stepperData = async (id) => {
      // Thin wrapper: fetch the ticket and delegate stepper-state
      // construction to useTicketStepper. The massive view's payload
      // uses `ticketGroupStates` instead of `states`, so we wrap it.
      try {
        await store.dispatch(FETCH_TICKET_ID, id).catch((e) => e.response);
        rebuildStepper({
          states: ticketData.value?.ticketGroupStates || []
        });

        // View-specific state derived from the composable's outputs.
        // The massive view historically uses ALL-CAPS text in the page
        // header, so we override the composable's default mixed-case
        // labels to preserve the existing UI.
        const last = ticketData.value?.ticketGroupStates
          ?.slice()
          .sort((a, b) => b.id - a.id)[0]?.state?.tag;
        const capsMap = {
          Creado: 'CREADO',
          'En aseguradora': 'EN ASEGURADORA',
          Ejecutado: 'EJECUTADO',
          Cancelado: 'CANCELADO'
        };
        if (capsMap[last]) {
          headerStateData.text = capsMap[last];
        }
        if (last === 'Creado' || last === 'En aseguradora') {
          finishAlta.value = true;
          headerStateData.show_buttons = last === 'En aseguradora';
        } else {
          finishAlta.value = false;
          headerStateData.show_buttons = false;
        }
        cancelTicket.value = last === 'Creado';
        loadTicket.value = false;
      } catch (error) {
        console.log('error', error);
      }
    };
    const handleCancelBajaButton = () => {
      showModalCancel.value = false;
    };
    const handleCancelBaja = async () => {
      loading.value = true;
      try {
        // Hago la request hacia la base de datos
        await store.dispatch(CANCEL_MASSIVE_MODIFICATION, ticketGroupId);
        await getTicketData();
        // Actualizo nuevamente el stepper para que se coloque automaticamente
        await stepperData(ticketGroupId);
        // records.push({
        //   title: 'Cancelado',
        //   description: response.data.createdAt
        // });
        loading.value = false;
      } catch (error) {
        loading.value = false;
        console.log(error);
      }
      //   loading.value = true;
      //   try {
      //     await store
      //       .dispatch(CANCEL_MASSIVE_EXCLUSION,{idAlta:ticketId.value,payload:formState})
      //       .then(() => {
      //         openNotificationWithIcon(
      //           'success',
      //           'Correcto',
      //           `Ticket ${ticketId.value} cancelado exitosamente`
      //         );
      //         getTicketData().then(() => {
      //           fillTableData();
      //           getBroker();
      //           fillIndividualTable();
      //         });
      //         formState.message='A través del presente correo solicitamos cancelar la información contenida en este correo, debido a que existe un error en el documento adjunto. Se generará otra solicitud con el archivo correcto.';
      //         formState.fileList[0]=[];
      //         showModalCancel.value=false;
      //         loading.value = false;
      //       });
      //   } catch (error) {
      //     loading.value = false;
      //     openNotificationWithIcon(
      //       'error',
      //       'Error',
      //       `No se ha podido cancelar el ticket ${ticketId.value}. ${error.response.data.message}`
      //     );
      //   }
    };
    const execute = async () => {
      loading.value = true;
      try {
        const response = await store.dispatch(
          EXECUTE_MASSIVE_MODIFICATION,
          ticketGroupId
        );
        // Actualizo nuevamente el stepper para que se coloque automaticamente
        await getTicketData();
        await stepperData(ticketGroupId);

        // Agrego una row más al historial
        records.push({
          title: 'Ejecutado',
          description: response.data.createdAt
        });
        loading.value = false;
      } catch (error) {
        loading.value = false;
        console.log(error);
      }
    };
    const handleExecuted = () => {
      Modal.confirm({
        title: () =>
          '¿Estás seguro que deseas ejecutar el ticket de modificación masiva?',
        icon: () => createVNode(ExclamationCircleOutlined),
        okText: () => 'Sí',
        cancelText: () => 'No',
        onOk() {
          execute();
        },
        onCancel() {}
      });
    };
    const handleCancel = async () => {
      Modal.confirm({
        title: () =>
          '¿Estás seguro que deseas cancelar el ticket de modificación masiva?',
        icon: () => createVNode(ExclamationCircleOutlined),
        okText: () => 'Sí',
        cancelText: () => 'No',
        onOk() {
          handleCancelBaja();
        },
        onCancel() {}
      });
      // showModalCancel.value=true;
    };

    const handleSuccess = async () => {
      loading.value = true;
      try {
        await store
          .dispatch(SUCCESS_MASSIVE_EXCLUSION, {
            idAlta: ticketGroupId,
            payload: payloadObject.value
          })
          .then(() => {
            openNotificationWithIcon(
              'success',
              'Correcto',
              `Ticket ${ticketGroupId} ejecutado exitosamente`
            );
            getTicketData().then(() => {
              fillTableData();
              getBroker();
              fillIndividualTable();
            });
            loading.value = false;
            visible.value = false;
          });
      } catch (error) {
        loading.value = false;
        openNotificationWithIcon(
          'error',
          'Error',
          `No se ha podido ejecutar el ticket ${ticketGroupId}. ${error.response.data.message}`
        );
      }
    };

    // * Comentarios
    // rol de  usuario
    const userRole = store.getters[GET_LOGGED_USER].roleName;

    // Obtencion de comentarios
    const comments = ref([]);
    const getComments = async () => {
      comments.value = [];
      const resp = await store.dispatch(FETCH_MASSIVE_COMMENTS, ticketGroupId);
      for (let i = 0; i < resp.length; i++) {
        const element = resp[i];
        const broker_name = await getBrokerName(element.brokerId);
        comments.value.push({
          description: parseDate(element.createdAt),
          title: element.message,
          author: broker_name
        });
      }
    };

    const getBrokerName = async (id) => {
      const response = await store.dispatch(FETCH_USER_BY_ID, id);
      return response.data.body.name;
    };

    const getNewCommment = async (value) => {
      const { description } = value;
      const { brokerId } = value;
      const brokerName = await getBrokerName(brokerId);

      comments.value.push({
        title: value.title,
        description: parseDate(description),
        author: brokerName
      });
    };

    getComments();

    return {
      // Variables
      stepperProps,
      rules,
      finishAlta,
      stepperRef,
      cancelTicket,
      headerStateData,
      handleCancelBaja,
      formRef,
      beforeUpload,
      handleRemove,
      formState,
      comments,
      loading,
      visible,
      showModalCancel,
      modalStyle,
      altasData,
      routes,
      ticketGroupId,
      tableData,
      insuranceMessage,
      attachedFiles,
      userRole,
      handleCancelBajaButton,
      // Methods
      handleCancel,
      handleExecuted,
      execute,
      handleSuccess,
      handleOk,
      getNewCommment,
      loadingDocument,
      loadTicket
    };
  }
};
</script>
